import { render } from "./checks-fill.vue?vue&type=template&id=bbb70a96"
import script from "./checks-fill.vue?vue&type=script&lang=js"
export * from "./checks-fill.vue?vue&type=script&lang=js"
script.render = render

export default script